// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Deveui_UplinkModel from '../../model/deveui-uplink-model';
import Deveui_UplinkDTO from '../dto/deveui-uplink-dto';
import dtoSchema from '../schemas/deveui-uplink-schema';
import CustomerdataModel from '../../model/customerdata-model';
import LrrsModel from '../../model/lrrs-model';

export default abstract class Deveui_UplinkModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Deveui_UplinkDTO>) {
    super();
    if (data) {
      this.adrbit = data.adrbit ?? undefined;
      this.channel = data.channel ?? undefined;
      this.customerData = CustomerdataModel.toModel(data.customerData);
      this.customerID = data.customerID ?? undefined;
      this.devAddr = data.devAddr ?? undefined;
      this.devEUI = data.devEUI ?? undefined;
      this.devLrrCnt = data.devLrrCnt ?? undefined;
      this.dynamicClass = data.dynamicClass ?? undefined;
      this.fcntDn = data.fcntDn ?? undefined;
      this.fcntUp = data.fcntUp ?? undefined;
      this.fport = data.fport ?? undefined;
      this.frequency = data.frequency ?? undefined;
      this.instantPER = data.instantPER ?? undefined;
      this.late = data.late ?? undefined;
      this.lostUplinksAS = data.lostUplinksAS ?? undefined;
      this.lrcid = data.lrcid ?? undefined;
      this.lrrESP = data.lrrESP ?? undefined;
      this.lrrid = data.lrrid ?? undefined;
      this.lrrLAT = data.lrrLAT ?? undefined;
      this.lrrLON = data.lrrLON ?? undefined;
      this.lrrRSSI = data.lrrRSSI ?? undefined;
      this.lrrs = data.lrrs ? LrrsModel.toModel(data.lrrs) : undefined;
      this.lrrSNR = data.lrrSNR ?? undefined;
      this.meanPER = data.meanPER ?? undefined;
      this.mic_hex = data.mic_hex ?? undefined;
      this.modelCfg = data.modelCfg ?? undefined;
      this.mtype = data.mtype ?? undefined;
      this.nbTrans = data.nbTrans ?? undefined;
      this.payload_hex = data.payload_hex;
      this.spFact = data.spFact ?? undefined;
      this.subBand = data.subBand ?? undefined;
      this.time = data.time;
      this.txPower = data.txPower ?? undefined;
    }
  }
  /**
  * @type {int32}
  */
  adrbit?: number;
  /**
  */
  channel?: string;
  /**
  */
  customerData?: CustomerdataModel;
  /**
  */
  customerID?: string;
  /**
  */
  devAddr?: string;
  /**
  */
  devEUI?: string;
  /**
  * @type {int32}
  */
  devLrrCnt?: number;
  /**
  */
  dynamicClass?: string;
  /**
  * @type {int32}
  */
  fcntDn?: number;
  /**
  * @type {int32}
  */
  fcntUp?: number;
  /**
  * @type {int32}
  */
  fport?: number;
  /**
  * @type {float}
  */
  frequency?: number;
  /**
  * @type {int32}
  */
  instantPER?: number;
  /**
  * @type {int32}
  */
  late?: number;
  /**
  * @type {int32}
  */
  lostUplinksAS?: number;
  /**
  */
  lrcid?: string;
  /**
  * @type {float}
  */
  lrrESP?: number;
  /**
  */
  lrrid?: string;
  /**
  * @type {float}
  */
  lrrLAT?: number;
  /**
  * @type {float}
  */
  lrrLON?: number;
  /**
  * @type {int32}
  */
  lrrRSSI?: number;
  /**
  */
  lrrs?: LrrsModel;
  /**
  * @type {float}
  */
  lrrSNR?: number;
  /**
  * @type {float}
  */
  meanPER?: number;
  /**
  */
  mic_hex?: string;
  /**
  */
  modelCfg?: string;
  /**
  * @type {int32}
  */
  mtype?: number;
  /**
  * @type {int32}
  */
  nbTrans?: number;
  /**
  * @minimum 10
  * @pattern 10
  */
  payload_hex?: string;
  /**
  * @type {int32}
  */
  spFact?: number;
  /**
  */
  subBand?: string;
  /**
  * @type {date-time}
  */
  time?: string;
  /**
  * @type {int32}
  */
  txPower?: number;

  static toModel(dto: DeepPartial<Deveui_UplinkDTO>): Deveui_UplinkModel;
  static toModel(dto: DeepPartial<Deveui_UplinkDTO> | undefined | null): Deveui_UplinkModel | undefined;
  static toModel(dto: DeepPartial<Deveui_UplinkDTO> | undefined | null): Deveui_UplinkModel | undefined {
    return dto ? new Deveui_UplinkModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Deveui_UplinkModel> | Deveui_UplinkModel): Deveui_UplinkDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      adrbit: unwrapped.adrbit,
      channel: unwrapped.channel,
      customerData: unwrapped.customerData,
      customerID: unwrapped.customerID,
      devAddr: unwrapped.devAddr,
      devEUI: unwrapped.devEUI,
      devLrrCnt: unwrapped.devLrrCnt,
      dynamicClass: unwrapped.dynamicClass,
      fcntDn: unwrapped.fcntDn,
      fcntUp: unwrapped.fcntUp,
      fport: unwrapped.fport,
      frequency: unwrapped.frequency,
      instantPER: unwrapped.instantPER,
      late: unwrapped.late,
      lostUplinksAS: unwrapped.lostUplinksAS,
      lrcid: unwrapped.lrcid,
      lrrESP: unwrapped.lrrESP,
      lrrid: unwrapped.lrrid,
      lrrLAT: unwrapped.lrrLAT,
      lrrLON: unwrapped.lrrLON,
      lrrRSSI: unwrapped.lrrRSSI,
      lrrs: unwrapped.lrrs,
      lrrSNR: unwrapped.lrrSNR,
      meanPER: unwrapped.meanPER,
      mic_hex: unwrapped.mic_hex,
      modelCfg: unwrapped.modelCfg,
      mtype: unwrapped.mtype,
      nbTrans: unwrapped.nbTrans,
      payload_hex: unwrapped.payload_hex,
      spFact: unwrapped.spFact,
      subBand: unwrapped.subBand,
      time: unwrapped.time,
      txPower: unwrapped.txPower,
    } as Deveui_UplinkDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Deveui_UplinkModel, can not map to Deveui_UplinkDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
